<p-accordionTab
  [ngStyle]="{ display: displayCss }"
  [header]="label"
  [selected]="selected"
  [ngClass]="[isMandatory ? 'mandatory' : '']"
  [attr.data-cy-accordion-name]="label"
>
  <ng-template iuDynamicContainer></ng-template>
</p-accordionTab>
